import { render, staticRenderFns } from "./evaStudentWrap.vue?vue&type=template&id=02b5c807&scoped=true&"
import script from "./evaStudentWrap.vue?vue&type=script&lang=js&"
export * from "./evaStudentWrap.vue?vue&type=script&lang=js&"
import style0 from "./evaStudentWrap.vue?vue&type=style&index=0&id=02b5c807&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b5c807",
  null
  
)

export default component.exports